export const SIGNAL_PROVIDERS = ['Ciko', 'Arep', 'Fira', 'Syuk', 'G'];

export const PROVIDER_COLORS = { Ciko: '#F97316', Arep: '#3B82F6', Fira: '#EC4899', Syuk: '#10B981', G: '#A855F7', '': '#6B7280' };

export const UNSET_LABEL = 'Belum ditetapkan';

export const providerLabel = (p) => p || UNSET_LABEL;
